module.exports = __webpack_public_path__ + "img/page1_1.5eb6b04d.png";